import React, { useContext } from 'react'
import { CheckoutStep } from '@/types'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import Container from './Container'
import Icon from './Icons'
import { IconWrapper, StepContainer, Step, Label, Wrapper } from './Stepper.styles'

const Stepper: React.FC<{ steps: CheckoutStep[] }> = ({ steps }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const isBookingEngine = defaultProperties?.agentConfiguration?.isBookingEngine

  return (
    <Wrapper>
      <Container size="narrow" noSpacingTop noSpacingBottom>
        <StepContainer>
          {steps.map(({ active, label, icon, complete }, index) => (
            <React.Fragment key={index}>
              <Step
                data-testid={`step-${label}-${active}`}
                complete={complete}
                bookingEngine={isBookingEngine ?? false}
              >
                <IconWrapper active={active} complete={complete} bookingEngine={isBookingEngine ?? false}>
                  {icon && <Icon name={icon} />}
                </IconWrapper>
                <Label active={active} complete={complete} bookingEngine={isBookingEngine ?? false}>
                  {label}
                </Label>
              </Step>
            </React.Fragment>
          ))}
        </StepContainer>
      </Container>
    </Wrapper>
  )
}

export default Stepper
